<div class="border-b border-solid border-slate-300"></div>

<div *ngIf="user$ | async as user" class="wrapper">
  <pr-manage-user
    hideRoles
    hideAccess
    [user]="user"
    [isLoggedInUser]="false"
    (inviteUser)="invite(user)"
  />
</div>
